import z from "zod";

import { DISCOUNT_DURATION, DISCOUNT_TYPE } from "@/shared/domains";

export const Coupon = z.discriminatedUnion("isValid", [
  z.object({
    code: z.string(),
    isValid: z.literal(false),
  }),
  z.object({
    code: z.string(),
    isValid: z.literal(true),
    duration: z.enum(DISCOUNT_DURATION),
    type: z.enum(DISCOUNT_TYPE),
    amountOff: z.number(),
    percentOff: z.number(),
    durationInMonths: z.number().nullable(),
    priceAfterDiscount: z.number(),
  }),
]);
export type Coupon = z.infer<typeof Coupon>;
